/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable react/hook-use-state */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState, useContext } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { API_URL } from "utils/constant";
import { UserContext } from "utils/reducers/user";
import { showToast } from "utils/helper";
import httpClient from "utils/apis/http-client";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
  DatePicker,
} from "@repo/ui";
import Layout from "components/layout";
import { Link } from "react-router-dom";
import { CirclePlusIcon, CircleX } from "lucide-react";
import {
  useCancelSplitRouteRequest,
  useGetSplitRouteRequests,
} from "utils/apis/split-route.api";
import { formatDate } from "date-fns";

const apiUrl = API_URL;

const currentDate = new Date();

function SplitRoute() {
  const user = useContext(UserContext);

  const [operationDate, setOperationDate] = useState(currentDate);
  const [handoverRequests, setHanoverRequests] = useState([]);

  const [showAddModel, setShowAddModel] = useState(false);

  const { data: handoverRequestsData, isPending: loader } =
    useGetSplitRouteRequests({
      cashCenterId: user.CashCenterId,
      operationDate: formatDate(
        operationDate || currentDate,
        "yyyy-MM-dd'T'00:00:00.000'Z'",
      ),
    });

  const { mutate: cancelRequest } = useCancelSplitRouteRequest();

  useEffect(() => {
    if (handoverRequestsData?.length) setHanoverRequests(handoverRequestsData);
    else setHanoverRequests([]);
  }, [handoverRequestsData]);

  const onOperationDateChanged = (value: Date) => {
    setOperationDate(value);
  };

  const toggleAddModel = () => {
    setShowAddModel(!showAddModel);
  };

  function CancelButtonCell({ dataItem }: any) {
    const { requestId } = dataItem;

    return (
      <td className="text-center mt-3">
        <Button
          variant="destructive"
          className="rounded-md w-full"
          onClick={() => {
            cancelRequest(requestId as string);
          }}
        >
          <CircleX />
        </Button>
      </td>
    );
  }

  function LocationCell(props: any) {
    const { locationBarcode, locationName } = props.dataItem;

    return (
      <td {...props}>
        {locationName}-{locationBarcode}
      </td>
    );
  }

  function DetailComponent(props: any) {
    const data = props.dataItem.details;

    if (data) {
      return (
        <Grid data={data}>
          <Column field="orderId" title="Order No" />
          <Column field="jobNo" title="Job No" />
          <Column title="Location" cell={LocationCell} />
          <Column field="serviceType" title="Service Type" />
          <Column field="jobType" title="Job Type" />
          <Column field="status" title="Status" />
          <Column field="reasons" title="Reasons" />
        </Grid>
      );
    }

    return (
      <div
        style={{
          height: "50px",
          width: "100%",
        }}
      >
        <div
          style={{
            position: "absolute",
            width: "100%",
          }}
        >
          <div className="k-loading-image" />
        </div>
      </div>
    );
  }

  const expandChange = async (event: any) => {
    event.dataItem.expanded = event.value;

    const index = event.dataIndex;

    setHanoverRequests([...handoverRequests]);

    if (!event.value || event.dataItem.detail) {
      return;
    }

    const data: any = handoverRequests.slice();

    const requestId = event.dataItem.requestId;

    const servicesEndpoint = `${apiUrl}/daily/operations/splitroute/request/jobs/${requestId}`;

    try {
      await httpClient.get(servicesEndpoint).then((res: any) => {
        if (res.status === 200) {
          data[index].details = res.data;
          setHanoverRequests(data);
        } else {
          data[index].details = [];
          setHanoverRequests(data);
          showToast("error", "No open services found.");
        }
      });
    } catch (error) {
      data[index].details = [];
      setHanoverRequests(data);
      showToast("error", "No open services found.");
    }
  };

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Direct Receiving & Handover</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card className="mx-4 mt-5">
        <CardContent className="pt-6">
          <div className="flex justify-end gap-4">
            <Link to="/create-split-route">
              <Button
                variant="secondary"
                className="w-max gap-2"
                onClick={toggleAddModel}
              >
                <CirclePlusIcon /> Create Request
              </Button>
            </Link>
            <div className="w-[250px]">
              <DatePicker
                placeholder="Select Operation Date"
                selectedDate={operationDate}
                onSelectDate={onOperationDateChanged}
              />
            </div>
          </div>
          <div className="border-b my-3 bg-accent" />

          {loader ? (
            <div className="k-loading-mask">
              <span className="k-loading-text">Loading</span>
              <div className="k-loading-image" />
              <div className="k-loading-color" />
            </div>
          ) : (
            <Grid
              data={handoverRequests}
              detail={DetailComponent}
              expandField="expanded"
              onExpandChange={expandChange}
            >
              {/* <Column
                field="controllerRouteNo"
                title="Controller Route No"
                width={180}
              /> */}
              <Column
                field="fieldTeamRouteNo"
                title="Field Team Route No"
                width={180}
                className="text-center"
              />

              <Column field="operationDate" title="Operations Date " />
              <Column field="createDateTime" title="Create Date & Time" />
              <Column field="splitRouteMethod" title="Split Method" />
              <Column field="splitReason" title="Reason" />
              <Column
                field="status"
                title="Status"
                width={200}
                className="text-center"
              />
              <Column
                width="80"
                title="Cancel"
                className="text-center"
                filterable={false}
                cell={CancelButtonCell}
              />
            </Grid>
          )}
        </CardContent>
      </Card>
    </Layout>
  );
}

export default SplitRoute;
